import { api } from './client'
import type { Dashboard, DashboardZones, GanttTask, ProjectLifecycleStage } from '@/types'

export const dashboardApi = {
  /** Legacy: плоский дашборд (используется временно, для совместимости). */
  get: () => api.get<Dashboard>('/dashboard'),

  /** Новый структурированный дашборд с 3 зонами (ФТ-ЭКРАН-002). */
  zones: () => api.get<DashboardZones>('/dashboard/zones'),

  /** Gantt-данные. Опционально: фильтр по этапу ЖЦ и/или ограничение одним проектом. */
  gantt: (stage?: ProjectLifecycleStage, projectId?: string) =>
    api.get<GanttTask[]>('/dashboard/gantt', {
      params: {
        ...(stage ? { stage } : {}),
        ...(projectId ? { project_id: projectId } : {}),
      },
    }),
}
